<template>
  <div class="kris-dopobr-box">
    <div id="table_classes" v-if="data !== false">
      <div class="panel-group" v-if="!isOld">
        <div class="" v-if="typeof (data.date_updated) !== 'undefined'">Дата актуальности данных:
          {{data.date_updated}}
        </div>
        <div v-bind:key="key" v-for=" (val,key) in data.items" class="panel">
          <div class="panel-heading">
            <div class="panel-title">
              <div :href="'#collapse_table_' + key" class="accordion-toggle collapsed" data-parent="#accordion"
                   data-toggle="collapse">
                {{ typeof val.group.items[0].CLASS !== 'undefined' ? val.group.items[0].CLASS.split('-').reverse().pop()
                : '' }} классы
              </div>
            </div>
          </div>
          <div :id="'collapse_table_' + key" class="panel-collapse collapse">
            <div class="panel-body">
              <table class="tbdefault2">
                <thead>
                <tr>
                  <th style="min-width:60px" class="first">Класс</th>
                  <th style="min-width:110px">Предметы углубленного изучения</th>
                  <th style="min-width:70px">Режим обучения</th>
                  <th style="min-width:80px">Смена</th>
                  <th style="min-width:65px">Количество учащихся</th>
                  <th style="min-width:110px">ФИО классного руководителя</th>
                </tr>
                </thead>
                <tbody v-if="typeof (val.group.items) !== 'undefined'">
                <tr v-bind:key="item.CLASS" v-for="item in val.group.items" class="child">
                  <td class="first">{{ item.CLASS }}</td>
                  <td>{{ item.INDEPTH_SUBJECTS }}</td>
                  <td>{{ item.EDU_MODE }}</td>
                  <td>{{ item.SHIFT }}</td>
                  <td>{{ item.PUPILS_QUANTITY }}</td>
                  <td>{{ item.FORM_MASTER }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading v-else/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Loading from './Loading'
import { GET_IS_OLD } from '../store/getters.types'

export default {
  name: 'Classes',
  components: {
    loading: Loading
  },
  computed: {
    ...mapState({
      data: 'classes'
    }),
    ...mapGetters({
      isOld: GET_IS_OLD
    })
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
